import { Pagination, Tooltip } from 'antd';
import { PaginationProps } from 'antd/es/pagination';
import Button from '../button/Button';
import { ArrowLeftIcon, ArrowRightIcon } from '../icons';
import { PagingParams } from '../../interfaces/Filter';
import { TablePageSize } from '../../utils/appconstants';

const CustomPagination = ({
    paging,
    updatePage
}: {
    paging?: PagingParams;
    updatePage: (page: number) => void;
}) => {
    const itemRender: PaginationProps['itemRender'] = (
        current,
        type,
        originalElement
    ) => {
        if (type === 'prev') {
            return;
        }
        if (type === 'next') {
            return;
        }
        if (type === 'page') {
            return <Tooltip title='Page'>{current}</Tooltip>;
        }
        return originalElement;
    };

    return (
        <div className='flex w-full bg-white items-center justify-between py-4 rounded-b-md px-5'>
            <Button
                text='Previous'
                leftIcon={<ArrowLeftIcon />}
                variant='secondaryOutline'
                disabled={Boolean(paging && paging?.page <= 0)}
                onClick={() => {
                    if (paging?.page && paging?.page > -1) {
                        updatePage(paging?.page - 1);
                    }
                }}
            />
            <Pagination
                total={paging?.total ?? 0}
                defaultCurrent={1}
                itemRender={itemRender}
                showSizeChanger={false}
                // align="center"
                pageSize={paging?.size}
                current={paging?.page as number + 1}
                onChange={(page) => {
                    updatePage(page - 1);
                }}
            />
            <Button
                text='Next'
                rightIcon={<ArrowRightIcon />}
                variant='secondaryOutline'
                disabled={Boolean(
                    paging &&
                        paging?.page * (paging?.size || TablePageSize) >
                            paging?.total
                )}
                onClick={() => {
                    if (paging) {
                        if (paging.page === -1) {
                            updatePage(1);
                        } else if (
                            paging &&
                            paging?.page * (paging?.size || TablePageSize) <
                                paging?.total
                        ) {
                            updatePage(paging.page + 1);
                        }
                    }
                }}
            />
        </div>
    );
};

export default CustomPagination;
